import { formatISO } from "date-fns";

import { StateKey } from "~/constants";

interface SubscribeNewsletterOptions {
  firstName: string;
  lastName: string;
  email: string;
  state: StateKey;
  isOverEighteen: boolean;
}

export const subscribeNewsletter = (v: SubscribeNewsletterOptions) => {
  v.state = v.state === "Other" ? "WA" : v.state;

  return fetch("/CampaignMonitor/Subscribe", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      firstName: v.firstName!,
      lastName: v.lastName!,
      email: v.email!,
      state: v.state,
      isOverEighteen: v.isOverEighteen,
    }),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw Error("CM Subscribe Network error");
    })
    .catch((err) => {
      throw err;
    });
};

interface User {
  firstName?: string;
  lastName?: string;
  email: string;
  state?: StateKey | null;
  completedModules?: string;
  dateLastUsed?: number;
}

export const upsertHealthyWorkplace = (user: User) => {
  return fetch("/CampaignMonitor/HealthyWorkplace", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...user,
      dateLastUsed: formatISO(user.dateLastUsed || Date.now()),
    }),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }

      throw Error("HWA Network error");
    })
    .catch((err) => {
      throw err;
    });
};
